export default "__VITE_ASSET__vk1e4ks7__"